import * as React from "react"
import { connect, Provider } from "react-redux"
import { URL } from "app/config/api-config"
import trans from "trans"
import store from "store"
import _find from "lodash/find"

import {
    css,
    Grid,
    GridCell,
    Message,
    Spinner,
    Placeholder,
    Paginator,
    Icon,
    Theme,
    modal,
} from "@bdfx/mergado-ui-kit"

import SectionLoader from "app/components/section-loader"


import { PreviewsForm, PreviewsData } from "template-previews/types"

import Image from "../components/image";

import { updateInputValue as change } from "app/reducers/form"
import ImagePreviewModalWrapper from "products/components/image-preview-modal-wrapper";
import { isJson } from 'app/helpers/other';
import { ReduxList } from "app/types/app-types"
import { Template } from "app/types/model-types"
import { selectFormValues } from "app/reducers/form"

export interface Props {
    change: typeof change
    previewsForm: PreviewsForm
    previews: PreviewsData
    isLoading: boolean
    templates: ReduxList<Template>
    updatePreviews: Function
    updateUserSetObjects: Function
}

export interface State {
    ver: number
}

class TemplatePreviews extends React.Component<Props, State>
{
    constructor(props: Props) {
        super(props)

        this.state = {
            ver: 0,
        }
    }

    incVer = () => {
        this.setState({ ver: this.state.ver + 1 })
    }

    showModal = (idx: number, altLevel: number) => {
        const { previews, previewsForm, templates } = this.props

        const productName = previews.items[idx]?.name
        const templateId = previews.items[idx]?.templateId

        const name = productName && isJson(productName) ? JSON.parse(productName) : null
        const firstName = name && name[0].name ? name[0].name : ''

        console.debug(`call show modal for idx ${idx} level ${altLevel}`, idx, altLevel)

        modal({
            overlayClassName: `image-preview-modal`,  //not working!!!!
            /* title: firstName || productName, */
            closeOnEscape: true,
            closeOnClickOutside: true,
            style: { maxWidth: '95vw', maxHeight: '95vh', minWidth: '90vw' },
            message: (close) => <Provider store={store}>
                <ImagePreviewModalWrapper
                    close={() => {
                        this.incVer()
                        close()
                    }}
                    idx={idx}
                    handlePaginator={this.handlePaginator}
                    isTheLast={previews.page === previews.last_page && previews && idx === previews.items.length}
                    isTheFirst={previews.page === 1 && idx < 1}
                    showUnmodified={previewsForm.view.rawImages > 0}
                    previews={previews}
                    updateUserSetObjects={this.props.updateUserSetObjects}
                />
            </Provider>
        })
    }

    handlePaginator = (page) => {
        this.props.change('previewsForm', 'view.page', page)
        this.props.updatePreviews({
            ...this.props.previewsForm,
            view: { ...this.props.previewsForm.view, page: page }
        })
    }

    renderPreviews(itemsPerRow: number) {
        const { previews, isLoading, previewsForm } = this.props
        const { ver } = this.state
        const ts = new Date().getTime()


        return previews.items.map((image, idx) => {
            const padding = image.templateSize ? (image.templateSize.height / image.templateSize.width) * 100 : (image.imageHeight/image.imageWidth) * 100;
            const style: React.CSSProperties = { position: "relative", paddingBottom: padding + '%' };

            const isTemplateActive = !!(image.templateActive || previewsForm.view.rawImages)
            const noCache = previewsForm.view.allowCache === 1 ? 0 : 1

            image.previewUrl = `${URL.laravelBase}images?template_id=${image.templateId}&product_id=${image.id}&nocache=${noCache}&ts=${ts}&ver=${ver}templatepreviews`

            if (previewsForm.view.rawImages === 1) {
                return (
                    <GridCell key={`preview-${image.id}-${idx}-${ver}`} className={`preview-image-raw`} style={{clear: (idx % itemsPerRow === 1) ? 'left' : 'none'}}>
                        <StyledPreviewDiv>
                            <Image
                                idx={idx}
                                image={image}
                                style={style}
                                showModal={this.showModal}
                                showUnmodified={true}
                                isTemplateActive={isTemplateActive}
                                templateActiveFrom={image.templateActiveFrom}
                                templateActiveTo={image.templateActiveTo}
                            />
                        </StyledPreviewDiv>
                    </GridCell>
                )
            }

            return (
                <GridCell key={`preview-${image.id}-${idx}-${ver}`} className={`preview-image`} style={{ clear: (idx % itemsPerRow === 1) ? 'left' : 'none', padding: "5px" }}>
                    <StyledPreviewDiv>
                        {isLoading ?
                            <Spinner />
                            :
                            <Image
                                idx={idx}
                                image={image}
                                isTemplateActive={isTemplateActive}
                                style={style}
                                showModal={this.showModal}
                                showUnmodified={false}
                                templateActiveFrom={image.templateActiveFrom}
                                templateActiveTo={image.templateActiveTo}
                            />
                        }
                    </StyledPreviewDiv>
                </GridCell>
            )
        })
    }

    renderPaginator = () => {
        const { previews, previewsForm } = this.props

        if (previews && previews.last_page > 1) {
            return (
                <Paginator
                    showFirstAndLast={true}
                    showPrevAndNext={true}
                    maxLinks={5}
                    labelFirst={`«« ${trans('first')}`}
                    labelPrevious={`« ${trans('previous')}`}
                    labelNext={`${trans('next')} »`}
                    labelLast={`${trans('last')} »»`}
                    currentPage={previewsForm.view.page}
                    lastPage={previews.last_page}
                    onPageChange={this.handlePaginator}
                />
            )
        }

        return <span />
    }


    render() {
        const { previews, isLoading } = this.props

        if (!previews || !previews.items) {
            return <SectionLoader />
        }

        const itemsPerRow = ((previews.items.length / 4) % 1) ? 3 : 4

        return (
            <StyledGrid>
                <GridCell>
                    {previews.from === 'project' &&
                        <Message
                            type="warning"
                            icon={<Icon type={'exclamation-triangle'} color={Theme.red} />} text={trans('no_products_in_query')}
                            closeable={false}
                        />
                    }
                </GridCell>

                <GridCell className="top">
                    {isLoading ? <Spinner type={'bubbles'} /> : this.renderPaginator()}
                </GridCell>

                <GridCell>
                    <Grid cols={`repeat(${itemsPerRow}, 1fr)`} gap='5px'>
                        {this.renderPreviews(itemsPerRow)}
                    </Grid>
                </GridCell>

                <GridCell className="bottom">
                    {this.renderPaginator()}
                </GridCell>
            </StyledGrid>
        )
    }
}

const StyledGrid = css(Grid)({
    textAlign: 'center',
});

const StyledPreviewDiv = css('div')({
    position: "relative",
    zIndex: "99",
    minHeight: "20vh",
    textAlign: "center",
    " .muk-spinner": {
        opacity: .8,
        margin: "auto",
        position: "absolute",
        top: "0px",
        bottom: "0px",
        left: "0px",
        right: "0px",
    },
    " .tag, & .tag-name": {
        position: "absolute",
        padding: "5px 20px",
        background: "rgba(0,0,0,0.7)",
        color: "white",
        bottom: 0,
        right: 0,
        top: 0,
        left: 0,
        margin: "auto",
        width: "100%",
        height: "30px",
        transition: "opacity 0.3s",
        opacity: 1,
        textAlign: "center"
    },
    " .tag-active-date": {
        height: "80px",
    },
    " .tag-name": {
        opacity: 0,
        top: 0,
        bottom: "initial",
        width: "100%",
        padding: "2px 5px",
        height: "auto",
        textAlign: "left",
        zIndex: 1
    },
    " .is-upscaled": {
        bottom: '40px',
        fontSize: '18px',
    },
    " :hover": {
        " .tag": {
            opacity: 0
        },
        " .tag-name": {
            opacity: 1
        }
    }
})

function mapStateToProps(state) {
    return {
        previewsForm: selectFormValues(state, 'previewsForm'),
        templates: state.templates,
    }
}

export default connect(mapStateToProps, {
    change,
})(TemplatePreviews)